var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sticker-message"},[_c('div',{staticClass:"chat-item-sticker"},[_c('img',{attrs:{"src":_vm.stickerMessage},on:{"error":_vm.imageUrlAlt}})])])}
var staticRenderFns = []

export { render, staticRenderFns }